import {
  Box,
  Container,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { psiTokens } from '../../theme/psiTheme';
import LogoCarousel from '../LogoCarousel';

// Drop matching PNG files into /public/logos/ (e.g. /public/logos/emerson.png)
// and the carousel will pick them up automatically — until then it falls
// back to showing the company name as text.
const clientLogos = [
  { name: 'Emerson', src: '/logos/emerson.png' },
  { name: 'FA Foundry', src: '/logos/fa-foundry.png' },
  { name: 'Smurfit Westrock', src: '/logos/smurfit-westrock.png' },
  { name: 'Marathon WEG', src: '/logos/marathon-weg.png' },
  { name: 'Copeland', src: '/logos/copeland.png' },
  { name: 'Nidec', src: '/logos/nidec.png' },
];

export default function Clients() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box
      sx={{
        backgroundColor: psiTokens.background.primary,
        py: isMobile ? 6 : 8,
      }}
    >
      <Container maxWidth="xl">
        {/* Section header */}
        <Box sx={{ mb: 5 }}>
          {/* Accent line */}
          <Box
            sx={{
              width: '40px',
              height: '3px',
              background: `linear-gradient(90deg, ${psiTokens.primary.dark}, ${psiTokens.primary.light})`,
              borderRadius: '2px',
              mb: 2,
            }}
          />

          <Typography
            sx={{
              fontSize: '11px',
              fontWeight: 600,
              letterSpacing: '0.15em',
              textTransform: 'uppercase',
              color: psiTokens.primary.light,
              marginBottom: 2,
            }}
          >
            Our Clients
          </Typography>

          <Typography
            variant="h2"
            sx={{
              color: psiTokens.text.primary,
              marginBottom: 2,
              fontWeight: 700,
            }}
          >
            Companies that have trusted PSI
          </Typography>

          <Typography
            sx={{
              fontSize: '15px',
              fontWeight: 400,
              color: psiTokens.text.tertiary,
              lineHeight: 1.8,
            }}
          >
            A track record built case by case.
          </Typography>
        </Box>

        {/* Client logos carousel */}
        <LogoCarousel items={clientLogos} intervalMs={3000} />
      </Container>
    </Box>
  );
}
